import { render, staticRenderFns } from "./FlipCarousel.vue?vue&type=template&id=4f2fa8a9&scoped=true"
import script from "./FlipCarousel.vue?vue&type=script&lang=js"
export * from "./FlipCarousel.vue?vue&type=script&lang=js"
import style0 from "./FlipCarousel.vue?vue&type=style&index=0&id=4f2fa8a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2fa8a9",
  null
  
)

export default component.exports